import { Game } from "../../game.js";
import { ImgID } from "../../image_loader/img_id.js";
import { ImagesHolder } from "../../image_loader/images_holder.js";
import { UIElement } from "./ui_element.js";

export class UIRimLightGlow extends UIElement
{
  private static readonly HALO_SCALE = 1.9;
  private static readonly halo_cache = new Map<string, HTMLCanvasElement>();

  private static haloCanvas( size: number, halo_rgb: string ): HTMLCanvasElement
  {
    const halo_r = size * UIRimLightGlow.HALO_SCALE;
    const px = Math.ceil( halo_r * 2 * Game.getDpr() );
    const key = `${halo_rgb}|${px}`;
    const cached = UIRimLightGlow.halo_cache.get( key );
    if ( cached )
      return cached;

    const canvas = document.createElement( "canvas" );
    canvas.width = px;
    canvas.height = px;

    const ctx = canvas.getContext( "2d" )!;
    const scale = px / ( halo_r * 2 );
    ctx.setTransform( scale, 0, 0, scale, px / 2, px / 2 );

    const halo = ctx.createRadialGradient( 0, 0, size * 0.2, 0, 0, halo_r );
    halo.addColorStop( 0, `rgba(${halo_rgb}, 1)` );
    halo.addColorStop( 0.35, `rgba(${halo_rgb}, 0.55)` );
    halo.addColorStop( 1, `rgba(${halo_rgb}, 0)` );

    ctx.beginPath();
    ctx.arc( 0, 0, halo_r, 0, Math.PI * 2 );
    ctx.fillStyle = halo;
    ctx.fill();

    UIRimLightGlow.halo_cache.set( key, canvas );
    return canvas;
  }

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    size: number,
    private img_id: ImgID,
    private halo_rgb: string
  )
  {
    super( ctx, x, y, size, size, false, false );
    this.setClickable( false );
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() ) return;

    this.startRender();

    const ctx = this.ctx;
    const size = this.rect.getW();

    const halo_r = size * UIRimLightGlow.HALO_SCALE;
    ctx.drawImage( UIRimLightGlow.haloCanvas( size, this.halo_rgb ), -halo_r, -halo_r, halo_r * 2, halo_r * 2 );

    const bulb = size * 1.3;
    const bulb_x = -bulb / 2;
    const bulb_y = -bulb / 2;
    ctx.globalCompositeOperation = "lighter";
    ctx.globalAlpha *= 0.8;
    ctx.drawImage( ImagesHolder.getImage( this.img_id ), bulb_x, bulb_y, bulb, bulb );

    this.finishRender();
  }

  public name(): string
  {
    return "UIRimLightGlow";
  }
}
